<template>
  <DpplSkeletonLoader>
    <DpplSvg file-name="score-meter-skeleton" />
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

export default {
  name: 'ScoreMeterSkeletonLoader',
  components: {
    DpplSkeletonLoader,
    DpplSvg,
  },
};
</script>
